import React from 'react';
import Text from 'Components/Text';

export default ({ type, category, name }) => {
  return (
    <section className='scene_section'>
      <header>General Information</header>
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Component Family Name'
        value={name}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _margin_right_30'
        textClassName='text__text_primary'
        label='Component Category'
        value={category ? category.name : ''}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Component Type'
        value={type.componentTypeName}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/GeneralInformation.jsx